<div class="tw-flex tw-items-stretch">
  @if (props['prepend']) {
    <span
      class="tw-flex tw-items-center tw-rounded-s tw-border tw-border-e-0 tw-border-cloud tw-bg-cloud-4 tw-px-3 tw-text-sm"
      >{{ props['prepend'] }}</span
    >
  }
  <input
    [placeholder]="props['placeholder']"
    [type]="type"
    [formControl]="formControl"
    class="hmm-input tw-flex-1"
    [class.tw-rounded-s-none]="props['prepend']"
    [class.tw-rounded-e-none]="props['append']"
    [formlyAttributes]="field"
  />
  @if (props['append']) {
    <span
      class="tw-flex tw-items-center tw-rounded-e tw-border tw-border-s-0 tw-border-cloud tw-bg-cloud-4 tw-px-3 tw-text-sm"
      >{{ props['append'] }}</span
    >
  }
</div>
